export enum INLINE_ACTIONS {
  RISK_MANAGEMENT_VULNERABILITIES = 'vulnerabilities',
}
